export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount)
}

export const calculateLineItemTotal = (
  quantity: number,
  unitPrice: number
): number => {
  return quantity * unitPrice
}
